import clsx from 'clsx';
import { Spinner } from 'components/UI';
import { TableBody } from 'components/UI/V3/Table/Body/TableBody';
import { TableCell } from 'components/UI/V3/Table/Cell/TableCell';
import { TableHeader } from 'components/UI/V3/Table/Header/TableHeader';
import { TableHeaderCell } from 'components/UI/V3/Table/HeaderCell/TableHeaderCell';
import { TableRow } from 'components/UI/V3/Table/Row/TableRow';
import { Table } from 'components/UI/V3/Table/Table';
import React from 'react';
import ChannelBadge from '../components/ChannelBadge';
import { formatCurrency, formatPercentage, SourceRow } from '../data/mockData';
import styles from './SourcePerformanceTable.module.scss';

interface SourcePerformanceTableProps {
    rows: Array<SourceRow>;
    loading: boolean;
}

export const SourcePerformanceTable: React.FC<SourcePerformanceTableProps> = props => {
    return (
        <Table firstColumnFixed>
            <TableHeader>
                <TableHeaderCell>Source</TableHeaderCell>
                <TableHeaderCell>Leads</TableHeaderCell>
                <TableHeaderCell>New Clients</TableHeaderCell>
                <TableHeaderCell>Conv. Rate</TableHeaderCell>
                <TableHeaderCell>Days to Book</TableHeaderCell>
                <TableHeaderCell>First Visit Revenue</TableHeaderCell>
                <TableHeaderCell>90-Day Revenue</TableHeaderCell>
                <TableHeaderCell>Avg. First Ticket</TableHeaderCell>
                <TableHeaderCell>Rebook Rate</TableHeaderCell>
            </TableHeader>
            <TableBody>
                {props.loading && (
                    <tr>
                        <td
                            colSpan={9}
                            className={styles.loadingCell}
                        >
                            <Spinner />
                        </td>
                    </tr>
                )}
                {!props.loading &&
                    props.rows.map(row => {
                        const isUnattributed = row.source.id === 'unattributed';

                        return (
                            <TableRow
                                key={row.source.id}
                                className={clsx(isUnattributed && styles.unattributedRow)}
                            >
                                <TableCell>
                                    <ChannelBadge
                                        bucket={row.source.bucket}
                                        label={row.source.name}
                                    />
                                </TableCell>
                                <TableCell>{row.leads}</TableCell>
                                <TableCell>{row.newClients}</TableCell>
                                <TableCell>{formatPercentage(row.convRate)}</TableCell>
                                <TableCell>
                                    {row.medianDaysToBook === 0 ? 'Same day' : `${row.medianDaysToBook} days`}
                                </TableCell>
                                <TableCell>{formatCurrency(row.revenueFirst)}</TableCell>
                                <TableCell className={styles.revenueCell}>{formatCurrency(row.revenue90d)}</TableCell>
                                <TableCell>{formatCurrency(row.aov)}</TableCell>
                                <TableCell>{formatPercentage(row.rebookRate)}</TableCell>
                            </TableRow>
                        );
                    })}
            </TableBody>
        </Table>
    );
};

export default SourcePerformanceTable;
